export const padlock = `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5198_28542)">
<path d="M30.6 0H5.4C2.41766 0 0 2.41766 0 5.4V30.6C0 33.5823 2.41766 36 5.4 36H30.6C33.5823 36 36 33.5823 36 30.6V5.4C36 2.41766 33.5823 0 30.6 0Z" fill="#282B34"/>
<path d="M24.3281 15.0469V12.4453C24.3281 3.79688 11.6719 3.79688 11.6719 12.4453V15.0469" fill="#282B34"/>
<path d="M24.3281 15.0469V12.4453C24.3281 3.79688 11.6719 3.79688 11.6719 12.4453V15.0469" stroke="#E0E0E0" stroke-width="3"/>
<path d="M25.9734 14.7656H9.88594C8.89183 14.7656 8.08594 15.5715 8.08594 16.5656V27.7312C8.08594 28.7254 8.89183 29.5312 9.88594 29.5312H25.9734C26.9676 29.5312 27.7734 28.7254 27.7734 27.7312V16.5656C27.7734 15.5715 26.9676 14.7656 25.9734 14.7656Z" fill="#99F1FF"/>
<path d="M18 22.7812C19.0873 22.7812 19.9688 21.8998 19.9688 20.8125C19.9688 19.7252 19.0873 18.8438 18 18.8438C16.9127 18.8438 16.0312 19.7252 16.0312 20.8125C16.0312 21.8998 16.9127 22.7812 18 22.7812Z" fill="#282B34"/>
<path d="M18.4219 20.8125H17.5781L16.4531 25.6641H19.5469" fill="#282B34"/>
</g>
<defs>
<clipPath id="clip0_5198_28542">
<rect width="36" height="36" fill="white"/>
</clipPath>
</defs>
</svg>`;
